import packageJson from '../../package.json'

export default {
  environment: 'prod',
  version: packageJson.version,
  web: {
    url: 'https://nol.yanolja.com',
  },
  policy: {
    url: '//policy.yanolja.com',
  },
  'order-gw': {
    url: 'https://order-gw.yanolja.com',
  },
  'point-site': {
    url: 'https://point-site-efin.yanolja.com',
  },
  place: {
    url: 'https://nol.yanolja.com/stay',
  },
  leisure: {
    url: 'https://leisure-web.yanolja.com',
  },
  customerCenter: {
    url: 'https://pf.kakao.com/_xexnXed',
  },
  globalBanner: {
    url: 'https://nol.yanolja.com/exhibition/9149',
  },
  yanoljaCancelFree: {
    url: 'https://content.yanolja.com/event/369',
  },
  dmTalk: {
    url: 'https://tour.yanolja.com',
  },
  app: {
    home: {
      url: 'nol-app://home',
    },
    search: {
      url: 'nol-app://search',
    },
    train: {
      url: 'yanoljamotel://train',
    },
    transportation: {
      url: 'nol-app://transportation',
    },
    appReviewPopup: {
      url: 'nol-app://etc/reviewpopup',
    },
    globalPlace: {
      url: 'nol-app://gplace',
    },
    mypage: {
      url: 'nol-app://etc',
    },
    wishlist: {
      url: 'nol-app://wishlist',
    },
    recentlist: {
      url: 'nol-app://etc/recentlist',
    },
  },
  aws: {
    credentials: {
      IdentityPoolId: 'ap-northeast-2:f1b4fd4d-e1c2-4b17-ae55-a738dd0c7ae9',
    },
    kinesis: {
      stream: 'live-ya-webclient-log',
    },
    region: 'ap-northeast-2',
  },
  google: {
    maps: {
      key: 'AIzaSyBudaFIDMrTMEemmk3cMk0ZcP07fTcBMV0',
      mapId: '5d1b95ef57d4353f6f1eca44',
    },
    form: {
      url: 'https://docs.google.com/forms/d/1-aZWJvf2MP04I_qMZaPMw_duT4CwkMhGsEH2UIE138I/viewform',
    },
  },
  naver: {
    maps: {
      key: 'c8eoad3uzp',
    },
  },
  kakao: {
    appKey: '3cf7cfbaf7ad7394f7d53b01eea4bdd6',
  },
  deeplink: {
    scheme: {
      place: {
        detail: 'yanoljamotel://place/detail',
      },
      leisure: {
        detail: 'yanoljamotel://leisure/detail',
      },
      train: 'yanoljamotel://train',
      bus: 'yanoljamotel://exbus',
    },
  },
  featureFlag: {
    pointIntg: {
      startAt: '2025-03-04T02:00:00+09:00',
    },
  },
  busLogoImage: {
    wide: {
      '01': 'https://image6.yanolja.com/platform-site/N4xXWhhRikUA9cML', // 금호고속
      '02': 'https://image6.yanolja.com/platform-site/Tmdk3zAtcbNIlCuy', // 동부고속
      '03': 'https://image6.yanolja.com/platform-site/l5yYcL8vhAoVuJAs', // 동양고속
      '04': 'https://image6.yanolja.com/platform-site/0Y5eqQLekcojxyfk', // 삼화고속
      '05': 'https://image6.yanolja.com/platform-site/Xo6Zrd1lq71acmYr', // 금호속리산고속
      '06': 'https://image6.yanolja.com/platform-site/TNKN5DEkmf9nKLLP', // 중앙고속
      '07': 'https://image6.yanolja.com/platform-site/oEweTsxTpCtQ19wq', // 천일고속
      '08': 'https://image6.yanolja.com/platform-site/N4xXWhhRikUA9cML', // 금호고속
      '09': 'https://image6.yanolja.com/platform-site/2CZikW1clCmRYmxR', // 한일고속
      '10': 'https://image6.yanolja.com/platform-site/l5yYcL8vhAoVuJAs', // 동양고속
      '11': 'https://image6.yanolja.com/platform-site/dxH9fVtllYnLXY87', // 경기고속
      '15': 'https://image6.yanolja.com/platform-site/idoSFodOjC04YuQM', // 대원고속
      '24': 'https://image6.yanolja.com/platform-site/v8HfPVlCYvA4cx1x', // 천여고속
      '29': 'https://image6.yanolja.com/platform-site/h58ggyp7HHgmMG57', // 코리아와이드경북
      '32': 'https://image6.yanolja.com/platform-site/VinoCaTrOBvRCjsL', // 서울고속
      '33': 'https://image6.yanolja.com/platform-site/VinoCaTrOBvRCjsL', // 새서울고속
      '38': 'https://image6.yanolja.com/platform-site/N4xXWhhRikUA9cML', // 금호고속
      '46': 'https://image6.yanolja.com/platform-site/com4WURcjIRmPfMv', // 경남고속
      '52': 'https://image6.yanolja.com/platform-site/qdjoTtGgTzPIccW0', // 충남고속
      '53': 'https://image6.yanolja.com/platform-site/wgTFKEFInidcIfGr', // 한양고속
      '59': 'https://image6.yanolja.com/platform-site/2CZikW1clCmRYmxR', // 한일고속
      '80': 'https://image6.yanolja.com/platform-site/N4xXWhhRikUA9cML', // 금호고속
    },
    square: {
      '01': 'https://image6.yanolja.com/platform-site/urpunomtqr8IlHKD', // 금호고속
      '02': 'https://image6.yanolja.com/platform-site/kth657YDOjreqCdy', // 동부고속
      '03': 'https://image6.yanolja.com/platform-site/TIuxoAkFormWZ746', // 동양고속
      '04': 'https://image6.yanolja.com/platform-site/pNRBEdF1AosoxtNh', // 삼화고속
      '05': 'https://image6.yanolja.com/platform-site/d7PpkpsI1eKYMUs4', // 금호속리산고속
      '06': 'https://image6.yanolja.com/platform-site/4InzEXFnDSxnY0nE', // 중앙고속
      '07': 'https://image6.yanolja.com/platform-site/9LD47I679QYzvIcG', // 천일고속
      '08': 'https://image6.yanolja.com/platform-site/urpunomtqr8IlHKD', // 금호고속
      '09': 'https://image6.yanolja.com/platform-site/SchV9NAsM3txYhWh', // 한일고속
      '10': 'https://image6.yanolja.com/platform-site/TIuxoAkFormWZ746', // 동양고속
      '11': 'https://image6.yanolja.com/platform-site/HoSkxEQZLCSbjv32', // 경기고속
      '15': 'https://image6.yanolja.com/platform-site/HkxRujqjotblMP7d', // 대원고속
      '24': 'https://image6.yanolja.com/platform-site/1uz8pdnlytvE7jJy', // 천여고속
      '29': 'https://image6.yanolja.com/platform-site/WDtzyh0yiETQ5cdb', // 코리아와이드경북
      '32': 'https://image6.yanolja.com/platform-site/7USOpeG071raVaY1', // 서울고속
      '33': 'https://image6.yanolja.com/platform-site/7USOpeG071raVaY1', // 새서울고속
      '38': 'https://image6.yanolja.com/platform-site/urpunomtqr8IlHKD', // 금호고속
      '46': 'https://image6.yanolja.com/platform-site/qks392OkGkODXRuE', // 경남고속
      '52': 'https://image6.yanolja.com/platform-site/qabLSIW3cAOp1rMw', // 충남고속
      '53': 'https://image6.yanolja.com/platform-site/0sIpKS3lDn3jASVU', // 한양고속
      '59': 'https://image6.yanolja.com/platform-site/SchV9NAsM3txYhWh', // 한일고속
      '80': 'https://image6.yanolja.com/platform-site/urpunomtqr8IlHKD', // 금호고속
    },
  },
  yanoljaCare: {
    url: 'https://nol.yanolja.com/event/19053',
  },
  trainPolicy: {
    start: '2023-05-24T10:00:00+09:00',
  },
  gaCodeKey: 'G-JVPP9KTQGG',
  googleAdsKey: 'AW-938422108',
  account: {
    url: 'https://accounts.yanolja.com',
  },
  nolMoney: {
    url: 'https://nol-money.yanolja.com',
  },
  nolMoneyImageSrc: {
    url: 'https://nol-money-image.yanolja.com',
  },
  tourGateway: {
    url: 'https://tour.yanolja.com',
  },
}
